import styled, { css } from 'styled-components'

interface VerticalLineProps {
  accentColor?: string
}

const StyledVerticalLine = styled.div<Pick<VerticalLineProps, 'accentColor'>>`
  ${({
    theme: {
      colors: { strokeBrand },
    },
    accentColor,
  }) => css`
    position: absolute;
    left: 0;
    background-color: ${accentColor ?? strokeBrand};

    height: 100%;
    width: 2px;
  `};
`

export default StyledVerticalLine
